import React from "react";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import { useNavigate } from "react-router-dom";
import { Button, Stack, styled, useTheme, useMediaQuery } from "@mui/material";

const Register = styled(Button)({
  textTransform: "none",
  color: "white",
  backgroundColor: "#117CB1",
  borderColor: "#46bcec",
  borderRadius: 10,
  boxShadow: "none",
  width: "265px",
  height: "50px",
  fontSize: "18px",
  marginRight: "40px",
  fontFamily: ["Helvetica Neue", "Helvetica", "Arial", "sans-serif"].join(","),
  "@media (max-width: 900px)": {
    width: "190px",
  },

  "@media (max-width: 600px)": {
    width: "130px",
    height: "45px",
    fontSize: "14px",
    marginRight: "25px",
  },
});

const WatchTutorial = styled(Button)({
  textTransform: "none",
  color: "#474747",
  backgroundColor: "#FFFFFF",
  border: "1px solid #117CB1 !important",
  borderRadius: 10,
  boxShadow: "none",
  width: "160px",
  height: "50px",
  fontSize: "18px",
  "&:hover": {
    color: "white",
  },
  fontFamily: ["Helvetica Neue", "Helvetica", "Arial", "sans-serif"].join(","),
  "@media (max-width: 900px)": {
    marginBottom: "5%",
    width: "190px",
  },
  "@media (max-width: 600px)": {
    width: "130px",
    height: "45px",
    fontSize: "14px",
  },
});

const openInNewTab = (url: string | URL | undefined) => {
  window.open(url, "_blank", "noopener,noreferrer");
};

const ImageBGComponent = (props: any) => {
  let history = useNavigate();

  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.down("md"));

  const styles = {
    imageHeader: {
      fontSize: { xs: "24px !important", lg: "34px !important" },
      width: "100%",
      marginBottom: "2%",
    },
    imageTypography: {
      fontWeight: 400,
      width: { sm: "65%", md: "100%" },
    },
  };

  return (
    <Paper
      sx={{
        position: "inherit",
        color: "#fff",
        mb: 1,
        background: {
          xs: "linear-gradient(180deg, #F0FAFF 0%, #F4FCFF 50%, #DFEBFF 100%)",
          sm: "linear-gradient(180deg, #F0FAFF 0%, #F4FCFF 50%, #DFEBFF 100%)",
          md: `url("${props.image}")`,
        },
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center", 
        boxShadow: "none !important",
        height: {xs: "260px",md: "265px"},
        borderRadius: "10px !important",
        paddingX: { xs: "25px", md: "50px" },
        paddingTop: { xs: "20px", md: "40px" },
        paddingBottom: { xs: "25px", md:"0"},
      }}
    >
      <Grid container>
        <Grid item md={6}>
          <Box sx={styles.imageTypography}>
            <Typography
              fontWeight="bolder"
              textAlign="left"
              component="h1"
              variant="h3"
              color="#00376A"
              sx={styles.imageHeader}
            >
              {props.title}
            </Typography>
            <Typography
              variant="h1"
              color="#6C6C89"
              marginTop="3%"
              sx={{
                margin: 0,
                fontFamily: "Roboto,Helvetica,Arial,sans-serif !important",
                fontWeight: "400 !important",
                fontSize: "1rem !important",
                lineHeight: "1.75 !important",
                letterSpacing: "0.00938em",
              }}
            >
              {props.description}
            </Typography>

            <Box marginTop="5%">
              <Stack direction="row" spacing={1}>
                <Box>
                  <Register
                    variant="contained"
                    onClick={() => history("/organization")}
                  >
                    {isXs ? "Register Now" : "Register Your Profile Now"}
                  </Register>
                </Box>
                <Box>
                  <WatchTutorial
                    variant="contained"
                    onClick={() =>
                      openInNewTab(
                        "https://www.youtube.com/watch?v=sHh24MKWCTM"
                      )
                    }
                  >
                    Watch Tutorial
                  </WatchTutorial>
                </Box>
              </Stack>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default ImageBGComponent;
